/**
 * This is the service which encapsulates all the http methods
 */
export class GenericServiceAjs {
    /*@ngInject*/
    constructor($q, $http) {
        this.$q = $q;
        this.$http = $http;
    }
    /**
     * This method is to perform any pre processing of error on request.
     * @param promise of the request to be cancelled
     */
    _handleError(error) {
        if (!_.isUndefined(error.developerMsg) && !_.isNull(error.developerMsg) && error.developerMsg != '') {
            error.message = error.developerMsg;
        }
        return error;
    }
    /**
     * This method allows the users to cancel a request by passing in the promise of that request.
     * @param promise of the request to be cancelled
     */
    cancelRequest(promise) {
        // If the promise does not contain a hook into the deferred timeout,
        // the simply ignore the cancel request.
        if (promise && promise._httpTimeout && promise._httpTimeout.resolve) {
            promise._httpTimeout.resolve('user cancellation');
        }
    }
    ;
    /**
     * This will allow to add object to DB by calling the api using http POST method.
     * @param url at which api is mapped
     * @param object to be added
     */
    addObject(url, object, additionalParams) {
        let deferred = this.$q.defer();
        let requestObject = {
            method: 'POST',
            url: url,
            data: object,
            timeout: deferred.promise
        };
        if (!_.isUndefined(additionalParams) && typeof additionalParams == 'object') {
            angular.forEach(additionalParams, (val, key) => {
                requestObject[key] = val;
            });
        }
        this.$http(requestObject).then((response) => {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, (response) => {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        // Store the deferred timeout on the promise so that our .cancel()
        // method can access it later, if necessary.
        deferred.promise._httpTimeout = deferred;
        return deferred.promise;
    }
    /**
     * This will allow to update the object by calling api using http PUT method
     * @param url at which api is mapped
     * @param object to be updated
     */
    putObject(url, object) {
        let deferred = this.$q.defer();
        this.$http({
            method: "PUT",
            url: url,
            data: object,
            timeout: deferred.promise
        }).then((response) => {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, (response) => {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        return deferred.promise;
    }
    /**
     * This will allow to get object by id, id of the object to be
     * fetched should be appended to the url.
     * @param url of the api with appended id.
     */
    getObjectById(url) {
        let deferred = this.$q.defer();
        this.$http({
            method: "GET",
            url: url,
            timeout: deferred.promise
        }).then((response) => {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, (response) => {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        // Store the deferred timeout on the promise so that our .cancel()
        // method can access it later, if necessary.
        deferred.promise._httpTimeout = deferred;
        return deferred.promise;
    }
    /**
     * This will allow to get all objects by calling backend API,
     * using http GET method,
     * @param url of api to be invoked
     */
    getObjects(url, additionalParams) {
        let deferred = this.$q.defer();
        let requestObject = {
            method: "GET",
            url: url,
            timeout: deferred.promise
        };
        if (!_.isUndefined(additionalParams) && typeof additionalParams == 'object') {
            angular.forEach(additionalParams, (val, key) => {
                requestObject[key] = val;
            });
        }
        this.$http(requestObject).then((response) => {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, (response) => {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        // Store the deferred timeout on the promise so that our .cancel()
        // method can access it later, if necessary.
        deferred.promise._httpTimeout = deferred;
        return deferred.promise;
    }
    /**
     * This will allow to delete object by calling api using http DELETE method
     * @param url at which api is mapped
     * @param object to be deleted
     */
    deleteObject(url, object) {
        let deferred = this.$q.defer();
        this.$http({
            method: "DELETE",
            url: url,
            data: object,
            headers: { 'Content-Type': 'application/json' },
            timeout: deferred.promise
        }).then((response) => {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, (response) => {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        return deferred.promise;
    }
    /**
     * This will allow to upload file by calling the api.
     * @param url at which api is mapped
     * @param object file object to be uploaded
     */
    uploadFile(url, object) {
        let deferred = this.$q.defer();
        this.$http({
            method: "POST",
            url: url,
            data: object,
            headers: { 'Content-Type': undefined },
            transformRequest: angular.identity,
            timeout: deferred.promise
        }).then((response) => {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, (response) => {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        return deferred.promise;
    }
}
//# sourceMappingURL=genericServiceAjs.js.map